export default __webpack_public_path__ + "static/media/Edit_NameServer_in_GoDaddy_box.875b8d28.webp";